import React from 'react';
import { defineMessages } from 'react-intl';
import { Features, FeaturesWideLayout } from 'acscp/components/auth/features/features';
import { LoyaltyMemberIcon } from 'acscp/components/common/icons/loyaltyMemberIcon';
import { LoyaltyPointsIcon } from 'acscp/components/common/icons/loyaltyPointsIcon';
import { LoyaltyClaimGiftIcon } from 'acscp/components/common/icons/loyaltyClaimGiftIcon';
import { LoyaltyGiftSelectionIcon } from 'acscp/components/common/icons/loyaltyGiftSelectionIcon';

const messages = defineMessages({
    becomeAMemberTitle: {
        id: 'web.components.pages.loyaltySchemeFeatures.becomeAMemberTitle',
        defaultMessage: '1. BECOME A MEMBER'
    },
    becomeAMemberText: {
        id: 'web.components.pages.loyaltySchemeFeatures.becomeAMemberText',
        defaultMessage:
            'Join the loyalty scheme and start earning points for any private jet charters you book.'
    },
    receivePointsTitle: {
        id: 'web.components.pages.loyaltySchemeFeatures.receivePointsTitle',
        defaultMessage: '2. RECEIVE LOYALTY POINTS'
    },
    receivePointsText: {
        id: 'web.components.pages.loyaltySchemeFeatures.receivePointsText',
        defaultMessage:
            'The more private jet charters you book, the more loyalty points you will be rewarded with. ' +
            'Simply login at any time to check the number of loyalty points you currently have.'
    },
    claimGiftsTitle: {
        id: 'web.components.pages.loyaltySchemeFeatures.claimGiftsTitle',
        defaultMessage: '3. CLAIM GIFTS'
    },
    claimGiftsText: {
        id: 'web.components.pages.loyaltySchemeFeatures.claimGiftsText',
        defaultMessage:
            'Use your loyalty points to redeem gifts. Simply earn enough points to claim a gift and we will send it out ' +
            'to you as soon as your order has been confirmed.'
    },
    selectionOfGiftsTitle: {
        id: 'web.components.pages.loyaltySchemeFeatures.selectionOfGiftsTitle',
        defaultMessage: '4. SELECTION OF GIFTS'
    },
    selectionOfGiftsText: {
        id: 'web.components.pages.loyaltySchemeFeatures.selectionOfGiftsText',
        defaultMessage:
            'A wide range of gifts are available to loyalty scheme members, from headphones and designer handbags to an ' +
            'iPhone and MacBook Pro.'
    }
});

export const LoyaltySchemeFeatures: React.FC = () => (
    <Features
        layout={FeaturesWideLayout.TwoRows}
        feature1={{
            icon: <LoyaltyMemberIcon/>,
            title: messages.becomeAMemberTitle,
            text: messages.becomeAMemberText
        }}
        feature2={{
            icon: <LoyaltyPointsIcon/>,
            title: messages.receivePointsTitle,
            text: messages.receivePointsText
        }}
        feature3={{
            icon: <LoyaltyClaimGiftIcon/>,
            title: messages.claimGiftsTitle,
            text: messages.claimGiftsText
        }}
        feature4={{
            icon: <LoyaltyGiftSelectionIcon/>,
            title: messages.selectionOfGiftsTitle,
            text: messages.selectionOfGiftsText
        }}
    />
);
